import { Button, HStack, Input } from '@chakra-ui/react'

import type { DiscountMode } from '../lib/premiumMath'

export const AmountInput = ({ value, mode, onValueChange, onModeChange }: {
  value: string
  mode: DiscountMode
  onValueChange: (value: string) => void
  onModeChange: (mode: DiscountMode) => void
}) => (
  <HStack
    spacing={2}
    borderWidth="1px"
    borderColor="gray.300"
    borderRadius="sm"
    bg="white"
    pl={3}
    pr={1.5}
    py={1}
  >
    <Input
      variant="unstyled"
      value={value}
      onChange={e => onValueChange(e.target.value)}
      placeholder="0"
      inputMode="decimal"
      textAlign="right"
      fontWeight="bold"
      fontSize="md"
    />
    <HStack spacing={0.5} bg="gray.100" borderRadius="sm" p={0.5} flex="none">
      {(['kc', 'percent'] as const).map(m => (
        <Button
          key={m}
          size="xs"
          variant={mode === m ? 'solid' : 'ghost'}
          colorScheme={mode === m ? 'primary' : 'gray'}
          onClick={() => onModeChange(m)}
          minW={8}
        >
          {m === 'kc' ? 'Kč' : '%'}
        </Button>
      ))}
    </HStack>
  </HStack>
)
